<mat-form-field>
  <mat-label>{{ label() || 'Timezone' }}</mat-label>
  <input
    [id]="id()"
    [name]="name()"
    [readonly]="readonly()"
    [required]="required()"
    [errorStateMatcher]="matcher"
    [formlyAttributes]="formlyAttributes()"
    [tabIndex]="tabIndex()"
    [placeholder]="placeholder()"
    type="text"
    aria-label="Choose a timezone"
    matInput
    [formControl]="searchControl"
    [matAutocomplete]="autocomplete"
  />
  @if (searchControl.hasError('invalidOption')) {
    <mat-error>{{ searchControl.getError('invalidOption').message }}</mat-error>
  } @else if (invalid()) {
    <mat-error><ng-content></ng-content></mat-error>
  }
  <mat-autocomplete #autocomplete="matAutocomplete" [displayWith]="displayFn()">
    @for (timezone of filteredTimezones$ | async; track timezone) {
      <mat-option [value]="timezone.name">
        {{ timezone.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
